import { IServiceAddress, IDocumentCartCheck } from '../types/buybox';
import { getCartState } from '@msdyn365-commerce/global-state';
import { ICoreContext } from '@msdyn365-commerce/core';
import { PropertyType } from '../propertyTypeEnum';

// function is to check duplicate in the cart
const checkDuplicateAtCart = async (
    rollAddress: IServiceAddress,
    context: ICoreContext<{ [x: string]: any }>,
    ItemId: string | undefined,
    documentToCheck?: IDocumentCartCheck
) => {
    let duplicateAddressAtCartLevel = false;
    // extracting line attributes from app cofig
    const { addressAttribute, searchKeyValueAttribute, documentAttribute } = context?.request.app.config;
    const cartState = await getCartState(context.actionContext);
    if (cartState.cart.CartLines) {
        for (let index = 0; index < cartState.cart.CartLines?.length; index++) {
            const cartLine = cartState.cart.CartLines[index];
            if (cartLine && cartLine.AttributeValues && cartLine.AttributeValues.length > 0) {
                const cocAddressAttr = cartLine.AttributeValues.find(x => x.Name === addressAttribute);
                const cocDocumentAttr = cartLine.AttributeValues.find(x => x.Name === documentAttribute);
                if (cocAddressAttr) {
                    // squence will be suite, number, stName, stType, quadrant
                    // @ts-ignore
                    const attrValue: string = cocAddressAttr.TextValue!;
                    const attrLength = attrValue.split('||').length;
                    // length will be used to check the address include suite or not
                    // check if address length is 5, it means address contain suite. if length is 4 it doesnot have suite
                    if (attrLength === 5 && rollAddress.suite) {
                        const [cartSuite, cartNumber, cartStreetName, cartStreetType, cartQuadrant] = attrValue
                            .split('||')
                            .map((val: string) => val?.trim().toLowerCase());
                        if (
                            cartSuite === rollAddress.suite?.toString().toLowerCase() &&
                            cartNumber === rollAddress.number?.toString().toLowerCase() &&
                            cartStreetName === rollAddress.streetName?.toString().toLowerCase() &&
                            cartStreetType === rollAddress.streetType?.toString().toLowerCase() &&
                            cartQuadrant === rollAddress.quadrant?.toString().toLowerCase()
                        ) {
                            //checking if current product Item ID is same as Cart line product item id
                            if (ItemId === cartLine.ItemId) {
                                duplicateAddressAtCartLevel = true;
                            }
                        }
                    } else if (attrLength === 4 && !rollAddress.suite) {
                        const [cartNumber, cartStreetName, cartStreetType, cartQuadrant] = attrValue
                            .split('||')
                            .map((val: string) => val?.trim().toLowerCase());
                        if (
                            cartNumber === rollAddress.number?.toString().toLowerCase() &&
                            cartStreetName === rollAddress.streetName?.toString().toLowerCase() &&
                            cartStreetType === rollAddress.streetType?.toString().toLowerCase() &&
                            cartQuadrant === rollAddress.quadrant?.toString().toLowerCase()
                        ) {
                            //checking if current product Item ID is same as Cart line product item id
                            if (ItemId === cartLine.ItemId) {
                                duplicateAddressAtCartLevel = true;
                            }
                        }
                    }
                } else if (documentToCheck && cocDocumentAttr) {
                    // @ts-ignore
                    const attrValue: string = cocDocumentAttr.TextValue!;
                    if (
                        documentToCheck.propertyType === PropertyType.community ||
                        documentToCheck.propertyType === PropertyType.quadrant ||
                        documentToCheck.propertyType === PropertyType.ats
                    ) {
                        const cocSearchKeyValueAttr = cartLine.AttributeValues.find(x => x.Name === searchKeyValueAttribute);
                        if (cocSearchKeyValueAttr) {
                            //@ts-ignore
                            const attrSKValue = cocSearchKeyValueAttr.TextValue!;

                            if (attrValue.includes(documentToCheck.documentId) && attrSKValue === documentToCheck.searchKey) {
                                if (ItemId === cartLine.ItemId) {
                                    duplicateAddressAtCartLevel = true;
                                }
                            }
                        }
                    } else if (documentToCheck.propertyType === PropertyType.blockProfile) {
                        const cocSearchKeyValueAttr = cartLine.AttributeValues.find(x => x.Name === searchKeyValueAttribute);
                        if (cocSearchKeyValueAttr) {
                            //@ts-ignore
                            const attrSKValue = cocSearchKeyValueAttr.TextValue!;

                            if (
                                attrValue.includes(documentToCheck.documentId) &&
                                attrSKValue === documentToCheck.searchKey &&
                                attrValue.includes(documentToCheck.documentName!)
                            ) {
                                if (ItemId === cartLine.ItemId) {
                                    duplicateAddressAtCartLevel = true;
                                }
                            }
                        }
                    } else if (
                        documentToCheck.propertyType === PropertyType.cityWide ||
                        documentToCheck.propertyType === PropertyType.none
                    ) {
                        if (attrValue.includes(documentToCheck.documentId)) {
                            if (ItemId === cartLine.ItemId) {
                                duplicateAddressAtCartLevel = true;
                            }
                        }
                    }
                }
            }
        }
    }
    return duplicateAddressAtCartLevel;
};

export default checkDuplicateAtCart;
